import { Box, Drawer, IconButton, Stack, SvgIcon, Typography } from '@mui/material';
import XIcon from '@untitled-ui/icons-react/build/esm/X';
import { getTime } from 'date-fns';
import { debounce, map } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEditSettingByKeyMutation } from 'src/api/setting-api';
import { Scrollbar } from 'src/components/scrollbar';
import { refreshKeyConfig } from 'src/config';
import { useServerError } from 'src/hooks/use-server-error';
import { selectSettings, setSetting } from 'src/pages/booking/slices/booking-slice';
import { setRefesh } from 'src/store/app-slice';
import InputSetting from './input-setting';

export const SettingsDrawer = (props) => {
  const { onClose, open, ...other } = props;
  const dispatch = useDispatch();
  const { processError } = useServerError();

  // const [settings, setSettings] = useState({});
  const settings = useSelector(selectSettings);

  const [editSettingByKey, { isLoading: isLoadingEditSettingByKey, isFetching: isFetchingEditSettingByKey }] =
    useEditSettingByKeyMutation();

  const handleSave = useCallback(
    debounce(({ key, value, valueType, setFieldLoading = () => {} }) => {
      setFieldLoading(true);

      // const setting = get(settings, key);
      // const settingValue = get(setting, 'value');

      // if (value !== settingValue) {
      // dispatch(setVariable({ [value.setting_key]: value.setting_value }));
      editSettingByKey({ key, value, valueType })
        .unwrap()
        .then(() => {
          dispatch(setSetting({ key, value }));
        })
        .catch((errors) => {
          processError(errors);
        })
        .finally(() => {
          setFieldLoading(false);
        });
      // }
    }, 200),
    []
  );

  useEffect(() => {
    if (isFetchingEditSettingByKey || isLoadingEditSettingByKey) {
      dispatch(
        setRefesh({
          [refreshKeyConfig.pageLoading]: getTime(new Date())
        })
      );
    } else {
      dispatch(
        setRefesh({
          [refreshKeyConfig.pageLoading]: false
        })
      );
    }
  }, [isFetchingEditSettingByKey, isLoadingEditSettingByKey]);

  return (
    <Drawer
      disableScrollLock
      anchor="right"
      onClose={onClose}
      open={open}
      ModalProps={{
        BackdropProps: {
          invisible: true
        },
        sx: { zIndex: 1400 }
      }}
      PaperProps={{
        elevation: 24,
        sx: {
          maxWidth: '100%',
          width: {
            xs: '100%', // 100% width on extra small screens
            sm: 380 // 380px width on small screens and up
          }
        }
      }}
      {...other}
    >
      <Scrollbar
        sx={{
          height: '100%',
          '& .simplebar-content': {
            height: '100%'
          },
          '& .simplebar-scrollbar:before': {
            background: 'var(--nav-scrollbar-color)'
          }
        }}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={3}
          sx={{
            px: 3,
            pt: 2
          }}
        >
          <Typography variant="h6">Cài đặt nhanh</Typography>

          <IconButton color="inherit" onClick={onClose}>
            <SvgIcon>
              <XIcon />
            </SvgIcon>
          </IconButton>
        </Stack>
        {/* <Stack spacing={2} sx={{ p: 3 }}> */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'minmax(100px, auto) 1fr',
            alignItems: 'center',

            p: 4,
            width: '100%',
            rowGap: 2
          }}
        >
          {map(settings, (setting, key) => (
            <InputSetting
              // typeField={item.setting_type}
              setting={setting}
              key={key}
              handleSave={handleSave}
              // onChange={(val) => {
              //    onChange(value.map((_item, _index) => (index === _index ? val : _item)));
              // }}
            />
          ))}
        </Box>
        {/* </Stack> */}
      </Scrollbar>
    </Drawer>
  );
};
